import { Observable } from 'rxjs';

export abstract class EuPageService {

    constructor(public http: any) { }

    abstract getPage(url: string, rows: number, page: number,
        cond?: Object, sidx?: string, sord?: string, _search?: boolean): Promise<any>

    abstract getPageOb(url: string, pageSize: number, page: number,
        cond?: Object, sidx?: string, sord?: string, _search?: boolean): Observable<any>

    abstract getPageObByOffsetLimit(url: string, offset: number, limit: number,
        cond?: Object, sidx?: string, sord?: string, _search?: boolean): Observable<any>

}